import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import log from 'loglevel';
import NeurographTable from '../../../components/Table';
import { FloatingSummary } from 'views/personas/home/Home';
import useRichInsights from 'hooks/useInsights';
import { getCustomerActivity } from './components/PersonasChart';
import { useHistory } from 'react-router-dom';

const columns = [
  { key: 'label', label: 'Name' },
  { key: 'totalVisitors', label: 'Visits' },
  { key: 'totalConversions', label: 'Conversions' },
  { key: 'aov', label: 'AOV' },
  { key: 'revenueLift', label: 'Revenue/Visit' },
  { key: 'lifetimeValue', label: 'Projected LTV' },
  { key: 'total', label: 'Total' }
];

export default function CustomerAcquisition() {
  const history = useHistory();
  
  const account = useSelector((state) => state.account);
  const knowledge = useSelector((state) => state.knowledge);

  useRichInsights();

  const [data, setData] = React.useState([]);

  const startDate = '2025-06-01'; // Example start date
  const endDate = '2025-06-30'; // Example end date

  // move this to hook once proper endpoint is set up
  useEffect(() => {
    const getData = async () => {
      const activity = await getCustomerActivity(
        account,
        startDate,
        endDate,
        'month'
      );

      // TODO: inlcude entity (persona) ids in aggregation call
      log.debug('Customer Activity:', activity);
      log.debug('Knowledge Entities:', knowledge.entities);

      const entityMap = knowledge.entities.reduce((agg, entity) => {
        agg[entity.name] = entity;
        return agg;
      }, {});

      const newDataMap = {};

      columns.forEach(({ key }) => {
        if (!activity[key]) {
          return;
        }

        activity[key].forEach((item) => {
          const currentItem = newDataMap[item.label] || {};

          currentItem.label = item.label;
          currentItem[key] = (item.data[0] || 0).toFixed(2);
          currentItem.id = entityMap[item.label] ? entityMap[item.label].id : null;

          newDataMap[item.label] = currentItem;
        });
      });

      setData(Object.values(newDataMap));
    };

    getData();
  }, [account]);

  const handleRowSelect = useCallback(entity => {
    console.log('Clicking on entity:', entity);
    history.push(`/admin/customers/acquisition/${entity.id}`);
  }, [])

  console.log('Customer Acquisition Data:', data);

  return (
    <div style={{
      marginTop: '32px', display: 'flex', flexDirection: 'column'
    }}
    >
      <div style={{ padding: '0 16px' }}>
        <NeurographTable
          columns={columns}
          data={data}
          handleRowSelect={handleRowSelect}
        />
      </div>
      <FloatingSummary />
    </div>
  );
}
